export default [
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000131',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 1,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '패티',
    PRESET_NM_KO: '패티',
    PRESET_NM_EN: 'PATTY',
    PRESET_NM_JP: 'パティ',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '002',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 500,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_ITEM_CD: '00000132',
    OPT_ITEM_TYPE: '0',
    OPT_ITEM_USE_TYPE: 'A',
    OPT_ITEM_ORDER: 2,
    OPT_ITEM_IMG_FILE_ID: '',
    OPT_ITEM_IMG_FILE_URL: '',
    ITEM_IMG_FILE_URL: '',
    SALES_QTY: 0,
    PRESET_NM: '토마토',
    PRESET_NM_KO: '토마토',
    PRESET_NM_EN: 'TOMATO',
    PRESET_NM_JP: 'トマト',
    PRESET_NM_CN: '',
    PRESET_NM_TW: '',
    CLAS_L_CD: '002',
    CLAS_M_CD: '001',
    CLAS_S_CD: '001',
    SALE_UPRC: 600,
    SVC_RATE: 0,
    TAX_FLG_CD: '1',
    TAX_RDC_FLG_CD: '1',
    SUPY_UPRC: 0,
    MG_RATE: 100,
    DC_ABLE_YN: 'Y',
    EVNT_NM: null,
    EVNT_KIND_CD: null,
    EVNT_FROM_DATE: null,
    EVNT_END_DATE: null,
    EVNT_FLG_CD: null,
    TIME_SALE_YN: null,
    TIME_SALE_FROM_TIME: null,
    TIME_SALE_END_TIME: null,
    EVNT_CD: null,
    EVNT_ITEM_CD: null,
    EVNT_DC_FLG_CD: null,
    EVNT_DC_AMT: null,
  },
];
